import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-movements',
  templateUrl: './no-movements.component.html',
  styleUrls: ['./no-movements.component.scss'],
})
export class NoMovementsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
